import { Pipe, PipeTransform } from '@angular/core';

// Regla única: la cuenta es de CrediTotal si perfil o empresa es 'CT'; el resto es Mundo Total.
const esCT = (v: any): boolean => String(v ?? '').trim().toUpperCase() === 'CT';

export function empresaDeCuenta(cuenta: any): 'CrediTotal' | 'Mundo Total' {
  return esCT(cuenta?.perfil) || esCT(cuenta?.empresa) ? 'CrediTotal' : 'Mundo Total';
}

// Aplica el filtro de empresa ('Todas' deja todo)
export function filtrarPorEmpresa(cuentas: any[], empresa: string): any[] {
  const lista = cuentas || [];
  return empresa === 'Todas' ? lista : lista.filter((c: any) => empresaDeCuenta(c) === empresa);
}

// Nombre de la empresa dueña de la cuenta
@Pipe({ name: 'empresaCuenta' })
export class EmpresaCuentaPipe implements PipeTransform {
  transform(cuenta: any): 'CrediTotal' | 'Mundo Total' {
    return empresaDeCuenta(cuenta);
  }
}

// Clase para el badge: 'ct' | 'mt'
@Pipe({ name: 'empresaCuentaClase' })
export class EmpresaCuentaClasePipe implements PipeTransform {
  transform(cuenta: any): 'ct' | 'mt' {
    return empresaDeCuenta(cuenta) === 'CrediTotal' ? 'ct' : 'mt';
  }
}
